import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvj6h44s4c: FaireProductEntity = {
  token: "p_pvj6h44s4c",
  type: "product",
  name: "Haunted Ghost Tour in Arkansas",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl:
    "https://cdn.faire.com/fastly/4d5fbee57592aef162dab0be4472a81a6755de316c43064d7f9951b166386444.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/410ef9877cf62230d4357adaf1726c08f5350eb077da49b45445c5846e03a3f1.jpeg",
    "https://cdn.faire.com/fastly/54e48854018dde8f81756c828337c67df434dab835ae80786d0d2e33f76434b3.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "Experience a fa-BOO-lous Halloween with Little Ghost on a tour of all the landmarks you know and love in ARKANSAS!\rLittle Ghost is going on a spooky Halloween tour around Arkansas, and you’re invited to ride along! Take a trip with the Ghost family as they travel from Bentonville to Eureka Springs and visit favorite landmarks such as Donald W. Reynolds Razorback Stadium and Thorncrown Chapel. Along the way, Little Ghost loves tricking everyone . . . until Little Ghost hears the biggest BOO ever! Make this Halloween season spook-tacular with this cute, not-so-scary rhyming picture book that takes you on an adventure through your home state.Explore your hometown: A read-aloud story that features art and text created especially for Arkansas, ideal for children ages 3-7\rHeartwarming fun:  Adorable illustrations feature landmarks from the Natural State such as Crystal Bridges Museum of American Art, The Old Mill, Arkansas State Capitol, and more\rInteractive storytime: Readers will join in t",
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:07.642Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
